var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3607 4.73121C27.2532 4.72013 27.1449 4.72013 27.0374 4.73121H4.95833C4.81682 4.73339 4.67625 4.75461 4.54041 4.79429L15.9348 16.1413L27.3607 4.73121Z",
    fill: "#253331"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5276 5.82727L17.0465 17.2611C16.751 17.5548 16.3513 17.7197 15.9347 17.7197C15.518 17.7197 15.1183 17.5548 14.8228 17.2611L3.44424 5.91401C3.40926 6.04257 3.39071 6.17505 3.38904 6.30828V22.079C3.38904 22.4973 3.55519 22.8984 3.85095 23.1942C4.14671 23.49 4.54785 23.6561 4.96611 23.6561H27.0452C27.4634 23.6561 27.8646 23.49 28.1603 23.1942C28.4561 22.8984 28.6222 22.4973 28.6222 22.079V6.30828C28.616 6.14399 28.584 5.98169 28.5276 5.82727ZM6.04641 22.079H4.95034V20.9514L10.683 15.2661L11.7948 16.3779L6.04641 22.079ZM27.0294 22.079H25.9254L20.177 16.3779L21.2888 15.2661L27.0215 20.9514L27.0294 22.079Z",
    fill: "#253331"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0afacf82f1b3ad7c45a7a6ce2841e15f.svg";
export { ForwardRef as ReactComponent };